module.exports = __webpack_public_path__ + "img/logo.778a56bf.png";